import { useDispatch } from "react-redux";
import useAppSelector from "@/core/helpers/useAppSelector";
import { estateSelector, setShowSaleConfirm } from "@/domains/estate/slice";
import useEstateBuy from "@/domains/estate/hooks/useEstateBuy.ts";
import EstateSaleConfirmModal from "@/domains/estate/components/EstateSaleConfirmModal.tsx";

export default function EstateSaleConfirmModalContainer() {
  const [buyEstate] = useEstateBuy();
  const estate = useAppSelector(estateSelector);
  const dispatch = useDispatch();

  return (
    <EstateSaleConfirmModal
      info={estate}
      onClose={() => dispatch(setShowSaleConfirm(false))}
      onConfirm={buyEstate}
    />
  );
}
